<template>
    <div>

    </div>
</template>

<script>
    import log from "utils/log"
    import {setToken} from "utils/auth"
    import apiHomePage from "@/api/home-page/index"

    export default {
        name:"redirect",
        props: {},
        computed: {},
        data() {
            return {
			}
        },
        methods: {
            getParams() {
				let s = location.search
				// location.search---------- ?code=061bsmed0GMw2z1ii1fd0pFned0bsmeY&state=123456
				console.log('location------------',location.search)
                let list = s.slice(1).split('&')
                let code = list[0]
                let state = list[1]
                if (code && state) {
					let wxCode = code.split('=')[1]
					this.$store.dispatch('mars/user/setWxCode', wxCode)
                    return {
                        wxCode:wxCode,
                        state: state.split('=')[1],
                    }
                }
			},
			

			handleNextStep(res) {
				console.log('请先绑定交费用户------',res)
				if(res.code === 5001) {
					let openId = res.data.openId
					this.$store.dispatch('mars/user/setOpenId', openId)
					this.$router.push('/login')
				}
			}
        },
        created() {
			let param = this.getParams()
			console.log('param-------------',param)
            if (param) {
                apiHomePage.getToken(param,{ handleNextStep: this.handleNextStep }).then(res => {
					// 存储 res data
					console.log(res)
                    let token = res.data
                    setToken(token)
                    this.$router.push({
                        name: 'home'
                    })
				})
				.catch( err => {
					console.log('getToken--------------获取token失败' + err)
					
				})
            }
        },
        mounted() {
        }

    }
</script>

<style lang='scss' scoped>

</style>
